import mitt from "mitt";

type Events = {
  [eventName: string]: any;
};
const emitter = mitt<Events>();

export const EventBus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
}
